import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import Cookies from "js-cookie";
import getTenantId from "../../components/Tenent";
import { showAccessDeniedModal } from "../slices/authSlice";
const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_TARGET_API}`,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = Cookies.get("access_token");
      const refresh_token = Cookies.get("refresh_token");

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Refresh"] = `Bearer ${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);

    const tenantId = getTenantId();

    const enhancedHeaders = {
      ...requestOpts.headers,
      "X-Tenant-Id": tenantId,
    };

    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: enhancedHeaders,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;

      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const targetdashboardapi = createApi({
  reducerPath: "targetdashboardapi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["targetdashboard"],
  endpoints: (builder) => ({
    getToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["activities"],
    }),

    Getgraphcategoriesdata: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),

    Getgraphcategoriesdatascope1: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),

    Getgraphcategoriesdatascope2: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),

    Getgraphcategoriesdatascope3: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),
    getNodewiseData: builder.query({
      query: ({ taxonomy, category }) => ({
        method: "GET",
        url: "/cs_nodewise_data",
        params: { taxonomy, category },
      }),
      providesTags: ["nodewise"],
    }),
    saveInitiative: builder.mutation({
      query: (initiativeData) => ({
        url: `/carbon_simulator_initiative_submit`,
        method: "POST",
        body: initiativeData,
      }),
      invalidatesTags: ["initiatives"],
    }),
    getAllInitiatives: builder.query({
      query: () => ({
        method: "GET",
        url: "/cs_initiative_view_individual",
      }),
      providesTags: ["initiatives"],
    }),
    getInitiativePhases: builder.query({
      query: (ids) => ({
        method: "GET",
        url: `/cs_initiative_phase_wise?initiative=${ids.join(",")}`,
      }),
      providesTags: ["initiatives"],
    }),
    getMACCvalues: builder.query({
      query: ({ids, currency}) => ({
        method: "GET",
        url: `/maqq_curve?initiative=${ids.join(",")}&currency=${currency}`,
      }),
    }),
    deleteInitiative: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `/carbon_simulator_initiative_delete/${id}`,
      }),
      invalidatesTags: ["initiatives"],
    }),
    saveScenario: builder.mutation({
      query: (initiativeData) => ({
        url: `/post_initiatives_scenario`,
        method: "POST",
        body: initiativeData,
      }),
      invalidatesTags: ["scenarios"],
    }),
    getScenarios: builder.query({
      query: (ids) => {
        if (ids && ids.length > 0) {
          return {
            method: "GET",
            url: `/get_scenarios?scenario_id=${ids.join(",")}`,
          };
        }
        return {
          method: "GET",
          url: `/get_scenarios`,
        };
      },
      providesTags: ["scenarios"],
    }),
    deleteScenario: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `/delete_scenario?scenario_id=${id}`,
      }),
      invalidatesTags: ["scenarios"],
    }),
    getCurrencies: builder.query({
      query: () => ({
        url: `/get_list_of_currencies`,
      }),
    }),
  }),
});

export const {
  useGetgraphcategoriesdataQuery,
  useGetgraphcategoriesdatascope1Query,
  useGetgraphcategoriesdatascope2Query,
  useGetgraphcategoriesdatascope3Query,
  useGetTokenMutation,
  useGetNodewiseDataQuery,
  useSaveInitiativeMutation,
  useGetAllInitiativesQuery,
  useGetInitiativePhasesQuery,
  useDeleteInitiativeMutation,
  useGetMACCvaluesQuery,
  useSaveScenarioMutation,
  useGetScenariosQuery,
  useDeleteScenarioMutation,
  useGetCurrenciesQuery,
} = targetdashboardapi;
